import { tagsQueryKeys } from '@/data/services/querykeys';
import Area from '@/models/Area';
import { useQuery } from '@tanstack/react-query';
import TagComponent from './Tag';

type TagsListProps = {
  area: Area;
};

export function TagsList({ area }: TagsListProps) {
  const { data: tags } = useQuery({
    ...tagsQueryKeys.list({ areaId: [area.id] }),
    enabled: true,
  });

  return (
    <ul className="flex flex-col gap-2.5">
      {tags?.results.map(tag => (
        <TagComponent key={tag.id} tag={tag} />
      ))}
    </ul>
  );
}
